import React, {useState} from "react";
import {CreditCard, PaymentForm} from "react-square-web-payments-sdk";
import { SQUARE_APP_ID, SQUARE_LOCATION_ID } from "../../squareConfig";
import {
	Button,
	FormGroup,
	Form,
	Container,
	Row,
	Col, Card, Modal,
} from "react-bootstrap";
import api from "../../api";
import {useAuth} from "../../AuthUser";
import {Navigate, useNavigate} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import MoneyBackImg from "../../assets/img/90day.png";
import { buildVerificationDetails, useSquareVerificationGuard } from "./squareSCA";

const PremierPlus = () => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const { setUser, user } = useAuth();
	const navigate = useNavigate();

	const notify = (message) =>
		toast.error(message, {
			position: toast.POSITION.TOP_RIGHT,
		});

	const { startGuard, clearGuard } = useSquareVerificationGuard({ notify });

	if (!user) {
		return <Navigate to="/pricing" replace />;
	}
	if (user.planType === '') {
		return <Navigate to="/dna-profile" replace />;
	}
	return (
		<Container>
			<Row>
				<Col sm={12} md={{ span: 6, offset: 3 }} lg={{ span: 6, offset: 3 }} xl={{ span: 6, offset: 3 }}>
					<Row className="align-items-center">
						<Col>
							<div className="d-grid gap-2 mt-4 mb-4">
								<h2 className="monument-font">DNA PREMIER+</h2>
								<ul className="list-unstyled">
									<li><i className="bi bi-check-circle text-success"/> UNLIMITED virtual lessons per month</li>
									<li><i className="bi bi-check-circle text-success"/> Live DNA consult at sign up</li>
									<li><i className="bi bi-check-circle text-success"/> 15 minutes of pocket pro time</li>
									<li><i className="bi bi-check-circle text-success"/> Access to entire video library</li>
									<li><i className="bi bi-check-circle text-success"/> Member only Q&A forum</li>
									<li><i className="bi bi-check-circle text-success"/> Free access to all webinars</li>
								</ul>
								<div className="d-flex align-items-center gap-1">
									<div className="h1">
										$167
									</div>
									<small className="">/month</small>
								</div>

							</div>
						</Col>
						<Col>
								<img
									src={MoneyBackImg}
									width={200}
									alt="moneyback"
								/>
						</Col>
					</Row>

					<h5 className="mb-3">Your Billing Details</h5>
					<PaymentForm
						applicationId={SQUARE_APP_ID}
						createVerificationDetails={() => buildVerificationDetails({ user })}
						cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
							clearGuard();
							handleShow();
							await api.post("/pay/create", {
								sourceId: token.token,
								verificationToken: verifiedBuyer?.token,
								planType: "plus",
							}).then(resp => {
								setUser(resp.data);
								handleClose();
								navigate("/thankyou", { replace: true });
							}).catch(err => {
								handleClose();
								notify(err.response?.data?.message || "Could not complete your payment — please try again or contact support@mygolfdna.com");
							})
						}}
						locationId={SQUARE_LOCATION_ID}
					>
						{/* onClickCapture, not buttonProps.onClick: the SDK's own click
						handler calls stopPropagation() before React's synthetic event
						system sees it, so an onClick passed via buttonProps never fires.
						Capture phase runs before that native handler does. */}
						<div onClickCapture={startGuard}>
							<CreditCard
								buttonProps={{
									css: {
										backgroundColor: "#157729",
										fontSize: "14px",
										color: "#fff",
										"&:hover": {
											backgroundColor: "#1f8c44",
										},
									},
								}}
							/>
						</div>
					</PaymentForm>
					<div className="mt-4 text-black-50">
						<p className="small">
							Your mygolfdna.com Premier+ Membership will start when you click "Pay"
</p>
						<p className="small">
							This is an auto-renewing payment plan. By clicking the button "Pay", you acknowledge that you are authorizing MyGolfDNA to charge your credit/debit card today for the Total Price listed above and $167.00/month thereafter until you cancel this subscription.
</p>
						<p className="small">
							A link to cancel can be found on your Account page. Your recurring payments will be immediately canceled, but you will maintain your current access until the end of the period for which you had fully paid and will not be charged again.
						</p>
					</div>
				</Col>
				</Row>
			<ToastContainer/>
			<Modal
				show={show}
				onHide={handleClose}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Body>
					<div className="text-center">
						<p>Processing Payment...</p>
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</Container>)
}

export default PremierPlus;
